import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function SingleVideoBand({ data }) {

    return (
        // FIXME: This code is untested and is a WIP
        <div key={data.documentId} className="single-video" style={{width:'100%'}}>
            <div className="views-row views-row-2 views-row-even" style={{width:'100%'}}>

                <article id="node-25" className="node node-video-gallery node-promoted node-teaser clearfix" about="/node/25" typeof="sioc:Item foaf:Document">

                    <div className="container-fluid video-container" style={{ maxWidth: "900px" }}>

                        <div className="row" style={{width:'100%'}}>

                            <div className="single-video col-xs-12 col-sm-12 col-sm-offset-1">
                                <iframe className="img-responsive video-control-featured" src={ data.video.youtubeVideoLink } allowFullScreen="">
                                </iframe>

                            </div>

                        </div>

                    </div>

                </article>

            </div>
        </div>
    );
}

export default SingleVideoBand;
